import ApartmentTile from './ApartmentTile.vue';

export { ApartmentTile };
export default ApartmentTile;
